<template>
  <div class="card-mobile" :class="{ open, active, lie, correct, wrong }" @click="setActive" :data-index="index">
    <div class="card-title">Κάρτα {{ index + 1 }}</div>
    <div class="text">{{ answer.text }}</div>
    <img src="@/assets/icons/more-info.svg" v-if="answer.moreInfo && !showResults" @click.prevent="showMoreInfo"
         class="more-info"/>

    <div class="icon-parent">
    <transition mode="out-in" name="icon">
      <img src="@/assets/icons/wrong.svg" v-if="wrong" @click.prevent="showMoreInfo" class="wrong-icon"/>
    </transition>

    <transition mode="out-in" name="icon">
      <img src="@/assets/icons/correct.svg" v-if="correct" @click.prevent="showMoreInfo" class="correct-icon"/>
    </transition>
    </div>

  </div>

  <InfoModal v-if="answer.moreInfo" ref="modal">
    <div v-html="answer.moreInfo" class="info"/>
  </InfoModal>
</template>

<script setup lang="ts">
import {ref, computed} from 'vue';
import InfoModal from "@/components/InfoModal.vue";
import {recordEvent} from "@/ts/helpers";

const props = defineProps(['answer', 'active', 'showResults', 'lie', 'index', 'open']);
const emit = defineEmits(['setActive']);

const modal = ref(null);

const lie = computed(() => {
  return props.showResults && props.lie;
});

const correct = computed(() => {
  return props.showResults && props.active && props.lie;
});

const wrong = computed(() => {
  return props.showResults && props.active && !props.lie;
});


const setActive = (e) => {
  if (e.target.classList.contains('more-info')) {
    return;
  }

  emit('setActive');
}

const showMoreInfo = () => {

  modal.value.show();

  recordEvent('quiz-more-info', 0);
  window.gtag('event', 'quiz-more-info');
};
</script>

<style scoped lang="scss">
.card-mobile {
  display: flex;
  position: absolute;
  height: calc(100% - 140px);
  width: 100%;
  padding: 30px 18px 70px;
  gap: 10px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  border-radius: 22px;
  border: 1px solid #454050;
  background: linear-gradient(301deg, rgba(0, 152, 153, 0.04) 11.85%, rgba(0, 210, 211, 0.06) 15.2%, rgba(0, 152, 153, 0.06) 17.86%, rgba(1, 3, 17, 0.00) 34.26%, rgba(1, 3, 17, 0.00) 69.48%, rgba(0, 210, 211, 0.05) 82.4%, rgba(0, 210, 211, 0.05) 83.09%, rgba(0, 152, 153, 0.02) 85.78%, rgba(1, 3, 17, 0.00) 88.67%), var(--iqos-slate, #34303D);
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25), 0px -2px 0.2px 1px rgba(197, 197, 197, 0.50);
  cursor: pointer;
  transition: top .3s cubic-bezier(0, 0, 0, 1), box-shadow .6s ease-in-out;
  will-change: top;
  top: calc(100% - 320px);
  -webkit-tap-highlight-color:  rgba(255, 255, 255, 0);

  &.open {
    top: 0;
  }

  .icon-parent {
    width: 60px;
    min-height: 60px;
  }
  .wrong-icon, .correct-icon, .nothing {
    width: 60px;
    height: auto;
    display: block;
  }

  @media screen and (min-height: 780px) {
    //height: 340px;
    //width: 220px;
    //padding: 96px 24px 24px;
    //gap: 24px;
    //--active-offset: -50px;
    //

    .wrong-icon, .correct-icon, .nothing {
      width: 71px;
      height: auto;
    }
  }

  --cards-offset: 70px;

  &:nth-child(1) {
    transform: translate3d(0, calc(var(--cards-offset) * 2), 0);
    z-index: 3;
  }

  &:nth-child(2) {
    transform: translate3d(0, calc(var(--cards-offset) * 1), 0);
    z-index: 2;
  }

  &:nth-child(3) {

  }

/*  &.active, &.lie {
    &:nth-child(1) {
      transform: translate3d(0, var(--active-offset), 0) rotate(-6deg);
    }

    &:nth-child(2) {
      transform: translate3d(0, var(--active-offset), 0) rotate(0deg);
    }

    &:nth-child(3) {
      transform: translate3d(0, var(--active-offset), 0) rotate(6deg);
    }
  }*/

  &.lie {
    box-shadow: 0px 8px 8px 0px rgba(0, 0, 0, 0.25), 0px 4px 40px 0px rgba(219, 54, 35, 0.15) inset, 0px -2px 0.2px 1px rgba(219, 54, 35, 0.70);
  }

  .text {
    color: #FFF;
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 180%;
  }

  &:not(.open) {
    .text {
      display: none;
    }
  }

}

.info {
  display: flex;
  flex-flow: column;
  justify-content: center;
}

.card-title {
  position: absolute;
  top: 22px;
  left: 0;
  width: 100%;
  color: var(--iqos-slate-50, #9A979E);
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 180%;
  &::before {
    content: "";
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%, 1px, 0);
    width: 104px;
    height: 1px;
    background: var(--iqos-slate-50, #9A979E);
    opacity: 0;
    transition: opacity .9s ease-out;
  }
}

.wrong .card-title {
  &::before {
    opacity: 1;
  }
}

.active .card-title {
  color: var(--iqos-white, #FFFDFB);

  &::before {
    background: var(--iqos-white, #FFFDFB);
  }
}


.icon-enter-active,
.icon-leave-active {
  transition: opacity 0.9s ease;
}

.icon-enter-from,
.icon-leave-to {
  opacity: 0;
}
</style>
